import React from 'react';
import cn from '@/utils/cn';

type Props = {
  alias: string;
  ariaHidden?: boolean;
  className?: string;
};

const StandardsTag = ({ alias, ariaHidden, className }: Props) => (
  <span
    aria-hidden={ariaHidden}
    className={cn('tw-bg-[#EEEAF4] tw-rounded-full tw-py-1 tw-px-5 tw-size-fit',
      'tw-font-tci tw-text-tci-purple tw-text-xs tw-font-bold',
      className)}
  >
    {alias}
  </span>
);

export default StandardsTag;
